import { Fragment } from 'react';
import branch from 'hocs/branch';

import { Helpful, RelatedLinks } from './components';

const formatDate = date => {
  const [weekDay, month, day, year] = new Date(date).toDateString().split(' ');

  return `${day} ${month} ${year}`;
};

const Article = ({ article: { createdAt, name, text } }) => (
  <Fragment>
    <h1 className="title section__article-title _mb-9">{name}</h1>
    <div className="section__article-date _mb-25 _mb-note-16">
      Posted {formatDate(createdAt)}
    </div>
    <div
      className="search-article"
      dangerouslySetInnerHTML={{ __html: text }}
    />
    {/* <Helpful /> */}
    {/* <RelatedLinks articleId={id} {...this.props} /> */}
  </Fragment>
);

export default branch(Article, () => <div className="spinner" />);
